import { render } from "./ProfileEmailEdit.vue?vue&type=template&id=bb51b754&lang=pug"
import script from "./ProfileEmailEdit.vue?vue&type=script&lang=js"
export * from "./ProfileEmailEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__